export const MARKETING_MEDIA = {
    heroVideo: {
        src: "https://eikoshealth-assets.s3.ap-south-1.amazonaws.com/marketing/videos/Hero_section_video.mp4"
    },
    doctorWebsiteVideo: {
        src: "https://eikoshealth-assets.s3.ap-south-1.amazonaws.com/marketing/videos/Website.mp4"
    },
    doctorAIScreen: {
        src: "https://eikoshealth-assets.s3.ap-south-1.amazonaws.com/marketing/videos/Doctor_AI.mp4"
    },
    patientViewScreen: {
        src: "https://eikoshealth-assets.s3.ap-south-1.amazonaws.com/marketing/videos/Patient+View.mp4"
    },
    doctorNotificationScreen: {
        src: "https://eikoshealth-assets.s3.ap-south-1.amazonaws.com/marketing/videos/Doctor_notification.mp4"
    }
} as const;
